module.exports = __webpack_public_path__ + "static/media/loginFondo.5a14773f.jpg";